import { sendContactEmailData } from '../coreApi';

export const sendContactEmail = async (emailData, captchaToken) => {
    try {
        await sendContactEmailData(emailData, captchaToken);
        return {
            status: 'success',
        };
    } catch (err) {
        return {
            status: 'error',
            message: 'Something went wrong. Please try again.',
        };
    } finally {
    }
};
